export const UploadFileActions = {
	UPLOAD: 'UPLOAD',
	PROCESSING: 'PROCESSING',
	SUCCESS: 'SUCCESS',
	ERROR: 'ERROR',
	FILE_ERRORS: 'FILE_ERRORS',
};
